import axios from 'axios'
import store from '../store';

const precheckout = {
  precheckout (purchase_id,purchase) {
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/domain_v2/precheckout/${purchase_id}.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: {
        purchase: purchase
      }
    });
  },
  ValidateCoupon(purchase_id,coupon_code) {
    return axios({
      method: "put",
			url: `${process.env.VUE_APP_API_EXP}/campaigns/validate_coupons/${purchase_id}.json`,
      data: {code:coupon_code}
    });
  },
  clearCluviPayData() {
    store.commit('order/SetTransaction', null, {root: true});
    store.commit('cluvipay/SetCluviPay',{
      payment_method: {},
      msg: {},
      purchase: {id:0}
    }, {root: true});
    store.commit('cluvipay/SetProfileSessionCluvipay',{id:0}, {root: true});
  }
}

export {
	precheckout
}
